import { render, staticRenderFns } from "./ModalIssueEndorsement.vue?vue&type=template&id=7079c968"
import script from "./ModalIssueEndorsement.vue?vue&type=script&lang=js"
export * from "./ModalIssueEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports